import { render, staticRenderFns } from "./UcWorksheetHeader.yaml?vue&type=template&id=8a749e46&component"
import script from "./UcWorksheetHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcWorksheetHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports